import "./index.scss";
import { forwardRef } from "react";
import { DSButton, Input } from "components/UI/atoms";
import { ReactComponent as SearchIcon } from "assets/search.svg";
import { ReactComponent as SearchButtonIcon } from "assets/search-button-icon.svg";

export const SearchBrandsInputHome = forwardRef((props, ref) => {
  const {
    placeholder,
    onInputChange,
    onInputFocus,
    onInputBlur,
    onFormSubmit
  } = props;

  return (
    <form
      noValidate
      className="search-brands-form-home"
      onSubmit={onFormSubmit}
    >
      <SearchIcon className="search-icon" />
      <Input
        customClassName="search-input"
        aria-label="Search"
        autoComplete="off"
        id="search-homepage"
        name="search"
        type="text"
        placeholder={placeholder}
        onChange={onInputChange}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        ref={ref}
      />
      <SearchButtonIcon
        className="search-input-icon"
        data-testid="search-input-icon"
      />
      <DSButton
        variant="secondary"
        size="large"
        customClassName="search-button-text"
      >
        SEARCH & SAVE
      </DSButton>
      <DSButton
        variant="secondary"
        size="default"
        icon={<SearchButtonIcon />}
        customClassName="search-button-icon"
        iconOnly
      />
    </form>
  );
});
